// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"60":"3b35699b","120":"314f0ff4","749":"442c169d","995":"b2aa14dc"}[chunkId] + ".js";
};